/**
 * Contributions « exceptionnelles » (hors YYYY-MM) : une entrée en base `month` par type et par membre.
 * Rétrocompat : la clé `adhesion` seule a été le premier format ; le préfixe `exceptional:` cible le reste.
 */
export const EXCEPTIONAL_PREFIX = 'exceptional:';

export function normalizeExceptionalTypeKey(raw) {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_')
    .slice(0, 40) || 'type';
}

/** Valeur de `month` stockée pour un type d’exceptionnelle. */
export function formatExceptionalMonthKey(typeKey) {
  const k = normalizeExceptionalTypeKey(typeKey);
  if (!k) return '';
  if (k === 'adhesion') return 'adhesion';
  return `${EXCEPTIONAL_PREFIX}${k}`;
}

export function parseExceptionalTypeKeyFromMonth(month) {
  const s = String(month || '').trim();
  if (!s) return null;
  if (s.toLowerCase() === 'adhesion') return 'adhesion';
  const p = s.toLowerCase();
  if (p.startsWith(EXCEPTIONAL_PREFIX)) {
    return normalizeExceptionalTypeKey(s.slice(EXCEPTIONAL_PREFIX.length)) || null;
  }
  return null;
}

export function isExceptionalMonthValue(month) {
  return parseExceptionalTypeKeyFromMonth(month) != null;
}

export function buildExceptionalTypesFromSettings(settings) {
  const fm = settings?.assistance?.financial_mechanics;
  const arr = fm?.exceptional_contribution_types;
  if (Array.isArray(arr) && arr.length > 0) {
    const out = arr
      .map((row) => ({
        key: normalizeExceptionalTypeKey(row?.key || row?.id),
        label: String(row?.label || '').trim(),
      }))
      .filter((row) => row.key && row.label);
    if (out.length) return out;
  }
  const legacy =
    String(fm?.exceptional_contribution_label || '').trim() || 'Contribution exceptionnelle';
  return [{ key: 'adhesion', label: legacy }];
}

export function typeKeyMatchesMonth(month, typeKey) {
  return formatExceptionalMonthKey(typeKey) === String(month || '').trim();
}
